export const AuthApiUrls = {
  login: '/auth/login',
  resetPassword: '/auth/password',
  requestPassword: '/auth/password',
  emailToken: '/auth/email-token',
};
